/** Normalizes optional website input to https URL or empty string. */
export function normalizeWebsiteUrl(raw: unknown): string {
  const trimmed = String(raw ?? '').trim();
  if (!trimmed) return '';
  if (/^https?:\/\//i.test(trimmed)) return trimmed;
  return `https://${trimmed}`;
}

export function phoneFromPlaceDetails(place: {
  international_phone_number?: string;
  formatted_phone_number?: string;
  internationalPhoneNumber?: string;
  nationalPhoneNumber?: string;
}): string | undefined {
  const phone = (
    place.international_phone_number ??
    place.formatted_phone_number ??
    place.internationalPhoneNumber ??
    place.nationalPhoneNumber ??
    ''
  ).trim();
  return phone || undefined;
}

/** Digits-only key for matching CRM leads by phone (Spain-aware). */
export function normalizePhoneForMatch(phone: string): string {
  const digits = phone.replace(/\D/g, '');
  if (!digits) return '';
  if (digits.startsWith('34') && digits.length >= 11) return digits;
  if (digits.length === 9) return `34${digits}`;
  return digits;
}

export function websiteFromPlaceDetails(place: {
  website?: string;
  websiteUri?: string;
}): string | undefined {
  const website = (place.website ?? place.websiteUri ?? '').trim();
  return website || undefined;
}
